import React, { Component } from 'react';
import {
  Button,
  Form,
  Message
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  translate
} from 'react-i18next';
class NewPasswordForm extends Component {

  render () {
    let {
      loading,
      error,
      oldPassword,
      newPassword,
      passwordDuplicate,
      createInputHandler,
      t,
      onSubmit
    } = this.props;

    // eslint-disable-next-line
    const eMessage = (message) => {
      return t(`newPassword.errors.${message.toLowerCase().substring(0,20)}`) || message;
    };

    const invalidData = oldPassword.length <= 3 || newPassword.length <= 3 || passwordDuplicate !== newPassword;
    return (
      <Form loading={loading} error={!!error}>
        <Message error header={(!!error && error.name) || undefined} content={(!!error && error.message) || undefined} />
        <Form.Input label={t("newPassword.form.fields.oldPassword")} type="password" value={oldPassword} onChange={createInputHandler('oldPassword')} />
        <Form.Input label={t("newPassword.form.fields.newPassword")} type="password" value={newPassword} onChange={createInputHandler('newPassword')} />
        <Form.Input label={t("newPassword.form.fields.passwordDuplicate")} type="password" value={passwordDuplicate} onChange={createInputHandler('passwordDuplicate')} />
        <Button disabled={invalidData} primary icon="send" fluid content={t("newPassword.form.buttons.send")} onClick={onSubmit} />
      </Form>
    );
  }

}

NewPasswordForm.propTypes = {
  loading: PropTypes.bool,
  oldPassword: PropTypes.string,
  newPassword: PropTypes.string,
  passwordDuplicate: PropTypes.string,
  createInputHandler: PropTypes.func,
  onSubmit: PropTypes.func
};

NewPasswordForm.defaultProps = {
  loading: false,
  error: null
};
const i18nEnhancement = translate('translations')(NewPasswordForm);
export default i18nEnhancement;



// WEBPACK FOOTER //
// ./src/components/forms/NewPasswordForm.jsx